module.exports = __webpack_public_path__ + "img/pattern1.82446a9.svg";